import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import UsersBasicInfoComponent from './users-basic-info.component';

export const UsersComponent = ({
    selectusers, handleInnerFormChange, back, handleFormSubmit, handleBasicFormChange, libraryData, users, changeProfileImage, eventTickets
}: any) => {
    const tabItems = [
        {
            id: 1,
            title: 'Users Basic Information',
            component: <UsersBasicInfoComponent
                handleInnerFormChange={handleInnerFormChange}
                selectusers={selectusers}
                handleBasicFormChange={handleBasicFormChange}
                libraryData={libraryData}
                users={users}
                changeProfileImage={changeProfileImage}
            />,
            isVisible: true,
        },
    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}

export default UsersComponent;
